module.exports = __webpack_public_path__ + "static/img/jt.c268bab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jt.png
// module id = 6Ne4
// module chunks = 1